import React from 'react'
import TreeFilter from 'components/TreeSelectFilter'
import { Row } from 'antd'

const YearFilter = ({ filterOptions,filterValues,handleFilterChange,handleFilterSearch }) => {
  return (
    <Row style={{ rowGap: '0px !important' }}>
      <TreeFilter
        width="50%"
        label="Year of Passing"
        placeholder="Select Year of Passing"
        treeData={filterOptions.yearList}
        value={filterValues.selectedYears}
        onChange={handleFilterChange}
        onSearch={handleFilterSearch}    
        valueKey='selectedYears'
      />
    </Row>
      
  )
}

export default YearFilter
